import React, {useEffect, useState} from "react";
import {Grid, Paper, Group, ThemeIcon, Container, Title, Badge, LoadingOverlay, Button} from "@mantine/core";
import api from "../../../services/api";
import {IconEye} from "tabler-icons";
import moment from "moment";
import DataTable from "react-data-table-component";
import {IconPencil} from "@tabler/icons";



export default function ListEvents({history}) {
    let token = localStorage.getItem('authorization');
    const [loading, setLoading] = useState(true);
    const [events, setEvents] = useState([]);


    function getEvents(){
        api.get('/admin/events', {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then( response => {
            setEvents(response.data.data);
            setLoading(false);
        })

    }

    useEffect(() => {
        getEvents();
    }, []);


    const columns = [
        {
            name: 'Título do Evento',
            selector: row => row.title,
        },
        {
            name: 'Descrição',
            selector: row => row.description,
        },
        {
            name: 'Data de Início',
            selector: row => moment(row.start_date).format("DD/MM/YYYY"),
        },
        {
            name: 'Data de Fim',
            selector: row => moment(row.end_date).format("DD/MM/YYYY"),
        },
        {
            name: 'Ação',
            center: true,
            cell: row => {
                return (
                    <Group position="apart">
                        <ThemeIcon variant="light" size="lg" radius="xl" color="#ffffff"
                                   style={{cursor: 'pointer', boxShadow: `0px 5px 10px rgba(143, 149, 178, 0.1)`}}
                                   onClick={() => history.push(`/eventos/${row.id}`)}>
                            <IconEye size={18} color="#8F95B2"/>
                        </ThemeIcon>
                        <ThemeIcon variant="light" size="lg" radius="xl" color="#ffffff"
                                   style={{cursor: 'pointer', boxShadow: `0px 5px 10px rgba(143, 149, 178, 0.1)`}}
                                   onClick={() => history.push(`/eventos/editar/${row.id}`)}>
                            <IconPencil size={18} color="#8F95B2"/>
                        </ThemeIcon>
                    </Group>
                )
            }
        },
    ];

    if (loading) {
        return <LoadingOverlay visible={loading} overlayBlur={2} />
    } else {
        return (
            <Container fluid>
                <Grid>
                    <Grid.Col xs={12}>
                        <Paper shadow="md" radius="md" p="md">
                            <Group position="apart">
                                <Title order={2} c="brand.6">Eventos MOS.GG</Title>
                                <Button onClick={() => history.push('/eventos/cadastrar')} >Adicionar Evento</Button>
                            </Group>

                            <DataTable theme="mosTheme" columns={columns}
                                       data={events}
                                       pagination
                                       paginationPerPage={20}
                                       progressPending={loading}
                            />
                        </Paper>
                    </Grid.Col>
                </Grid>
            </Container>
        )
    }
}